const HOTKEY_EVENT_NAMES = [
  "addTopNav",
  "closeModal",
  "closeTopNav",
  "createNew",
  "executeRequest",
  "focusAddressBar",
  "focusRequestSearch",
  "jumpToLastTab",
  "jumpToTab",
  "navigateSearchResultsDown",
  "navigateSearchResultsUp",
  "navigateTopNavLeft",
  "navigateTopNavRight",
  "openCommandPalette",
  "selectSearchResult",
  "toggleSidebar"
];
const KEYDOWN_KEYS = [
  "Space",
  "Backspace",
  "Tab",
  "Enter",
  "Escape",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight",
  "ArrowUp",
  "End",
  "Home",
  "PageDown",
  "PageUp",
  "Delete",
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "*",
  "+",
  "-",
  ".",
  "/",
  "F1",
  "F2",
  "F3",
  "F4",
  "F5",
  "F6",
  "F7",
  "F8",
  "F9",
  "F10",
  "F11",
  "F12",
  ";",
  "=",
  ",",
  "-",
  ".",
  "/",
  "`",
  "[",
  "\\",
  "]",
  ""
];
export {
  HOTKEY_EVENT_NAMES,
  KEYDOWN_KEYS
};
//# sourceMappingURL=hotkeys.js.map
